import { appStore } from "@app/store/store"
import { useSelector } from "@tecreation/js-state-react"

export default function ZoneSelector(zone) {
	const sZoneId = useSelector("core.zoneId")
	const { title, zoneId } = zone

	return (
		<div
			className="flex clickable py-2"
			onClick={() => {
				appStore.set("core.zoneId", zoneId)
				appStore.set("order.loungers", [])
				appStore.set("order.loungerPrice", 0)
			}}
		>
			<div className="mr-2">
				<input type="radio" readOnly checked={zoneId === sZoneId} />
			</div>
			<div>{title}</div>
		</div>
	)
}
